import { render, staticRenderFns } from "./ContractorNew.vue?vue&type=template&id=67dd729c&"
import script from "./ContractorNew.vue?vue&type=script&lang=js&"
export * from "./ContractorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports